import React from 'react';
import '../css/navBar.css';
import '../css/registro.css';

function Resumen(){

    
    
    return(  
        <>  
            <div id="resumen" className='d-none'>

            </div>
        </>
    );
}


export default Resumen;